import React, { useMemo } from 'react'
import { ListBox } from 'primereact/listbox'
import { prettyMetricsName } from './helpers'
import { AttributeMetricsOptions } from './types'
import mcss from './Attribute.module.scss'

interface ListBoxSelectionEvent<T> {
  value: T
}

type ListBoxOption = { value: string; label: string }

export function AttributeOptionsList({
  options,
  onSelect,
  selectedDefault,
  selectedList = []
}: {
  options: AttributeMetricsOptions
  selectedDefault: string
  selectedList: string[]
  onSelect: (arg: string) => void
}) {
  const listBoxOptions = useMemo(
    () =>
      options
        ? options
            .filter(({ id }) => id !== selectedDefault && !selectedList.includes(id))
            .map<ListBoxOption>(
              ({ id: value, name }) => Object({ value, label: prettyMetricsName(name) }) as ListBoxOption
            )
        : [],
    [options, selectedDefault, selectedList]
  )
  const handleOnChange = (event: ListBoxSelectionEvent<string>) => {
    onSelect(event.value)
  }

  return (
    <ListBox
      value={null}
      options={listBoxOptions}
      onChange={handleOnChange}
      className={mcss['options-list-wrapper']}
      emptyMessage={<span className="p-text-secondary">No more metrics to use</span>}
    />
  )
}
